import { PriceUpdateEmailDataInputRow } from "@/client-admin";
import { DataTable } from "@/components/PriceUpdate/PriceUpdateEmailTable/data-table";
import { columns } from "./columns";

interface PriceUpdateEmailTableProps {
  data: PriceUpdateEmailDataInputRow[];
  title?: string;
  product?: string;
}

export function PriceUpdateEmailTable({ data, title, product }: PriceUpdateEmailTableProps) {
  if (!data || data.length === 0) {
    return null;
  }

  const dataWithProduct = data.map((row) => ({
    ...row,
    product: product || title?.toLowerCase().replace(/\s+/g, "_"),
  }));

  return (
    <div>
      {title && <h3 className="mb-2 font-medium">{title}</h3>}
      <DataTable columns={columns} data={dataWithProduct} />
    </div>
  );
}
